import {Injectable} from "@angular/core";
import {Log} from "./model/log";
import {LogsSort} from "../../sort-funcions/logs-sort";

@Injectable({
    providedIn: 'root'
})
export class LogService {
    
    logs=[];
    
    save(message: string, pointer?: string) {
        const log = new Log(new Date().getTime(), message, pointer);
        this.persistLog(log);
    }

    getAll(): Log[] {
        return this.logs.sort(LogsSort.compareFn);
    }
    
    private async persistLog(log){
        this.logs.push(log);
        localStorage.setItem('log', JSON.stringify(log));
    }
    
    
}